import component from './features.vue'

export default component
